import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { ControlContainer, FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { InputBase } from '../input-base/input-base';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'mbs-input-password',
  templateUrl: './input-password.component.html',
  imports: [InputComponent, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputPasswordComponent extends InputBase<any> implements OnInit {
  private controlContainer = inject(ControlContainer, { optional: true, host: true, skipSelf: true });
  protected cd: ChangeDetectorRef;

  public control: FormControl;

  @Input() validationWhitespace = true;
  @Input() disabledEye = false;
  /**
   * Add font-weight-bold;
   */
  @Input() public boldLabel = false;
  /**
   * Disable input with ignore FormControl warnings
   */
  @Input() public disabledSelf = false;
  /** Displaying '*' for required fields is the default behavior, but can be overridden. */
  @Input() public showRequiredMark = true;

  @Input() passwordInputType: 'password' | 'text' = 'password';

  @Input() formControlName?: string;
  @Input() autocomplete: 'on' | 'off' | 'new-password' | string;
  @Input() tooltip?: string;

  constructor() {
    const ngControl = inject(NgControl, { optional: true, self: true });
    const cd = inject(ChangeDetectorRef);

    super();

    this.cd = cd;
  }

  ngOnInit() {
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName) as FormControl;
      } else {
        console.warn('Missing formControlName directive');
      }
    } else {
      this.control = this.ngControl.control as FormControl;
    }
  }

  changeTypePassword(): void {
    this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
  }
}
